/*http配置*/
import axios from 'axios';
import router from '../router';
import ifconfig from './ipConfig';
import ip from './ip';

// axios配置
const instance = axios.create({
    timeout: 180000,
    headers: Object.assign({}, ifconfig.headers)
});

export default instance


// WEBPACK FOOTER //
// ./src/config/http.js